// extracted by mini-css-extract-plugin
export var header = "_fs-0";